import React from "react";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import CartDrawer from "@/components/CartDrawer";
import Seo from "@/components/Seo";
import Story from "@/components/Story";
import { PageLead } from "@/components/PageLead";
import RitualOrigin from "@/components/RitualOrigin";
import { useLang } from "@/i18n";
import { breadcrumbLd, organizationLd, pageLd } from "@/lib/seo";

const Historia = () => {
  const { lang, t } = useLang();

  return (
    <div className="bg-[#F5F1E8] overflow-x-hidden">
      <Seo
        title={t.seo.historia.title}
        description={t.seo.historia.description}
        path="/historia"
        lang={lang}
        type="article"
        jsonLd={[
          organizationLd(),
          breadcrumbLd([
            { name: "Naguarà", path: "/" },
            { name: t.nav.story, path: "/historia" },
          ]),
          pageLd("AboutPage", {
            name: t.seo.historia.h1,
            description: t.seo.historia.description,
            path: "/historia",
          }),
        ]}
      />
      <Navbar />
      <div className="h-20 bg-[#422D28]" aria-hidden="true" />
      <main data-testid="page-historia">
        <PageLead pageKey="historia" title={t.seo.historia.h1} />
        <Story />
        <RitualOrigin />
      </main>
      <Footer />
      <CartDrawer />
    </div>
  );
};

export default Historia;
